// Modules
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Styles
import styles from './PaymentMethodButtons.module.scss';

function generateButtons(selected, arr, callback) {
  return arr.map((button) => {
    const {
      paymentType,
      amount,
      heading,
      description,
      isPopular,
      paymentMethod,
    } = button;

    const isSelected = selected === paymentType;

    return (
      <button
        className={`${
          isSelected ? [styles.btn, styles.btnSelected].join(' ') : styles.btn
        } ${paymentType === 'savedCard' ? styles.savedCard : ''}`}
        onClick={() => callback(paymentType)}
        key={`${paymentType}${amount}`}
        type='button'
      >
        <div className={styles.verticalAlign}>
          <span
            className={
              isSelected
                ? [styles.circle, styles.circleSelected].join(' ')
                : styles.circle
            }
          >
            {isSelected ? (
              <FontAwesomeIcon icon={['fas', 'check-circle']} />
            ) : (
              <FontAwesomeIcon icon={['far', 'circle']} />
            )}
          </span>
        </div>

        {paymentType !== 'savedCard' && (
          <>
            <div className={styles.firstCol}>
              <p className={styles.heading}>{heading}</p>
              <p className={styles.description}>{description}</p>
            </div>

            <div>
              {paymentType === 'installments' && (
                <p className={styles.amount}>
                  <sup>$</sup>
                  {amount}
                  <sub>/m</sub>
                </p>
              )}
              {isPopular ? (
                <span className={styles.isPopular}>
                  <FontAwesomeIcon icon={['fas', 'star']} />
                  <span style={{ marginLeft: '5px', lineHeight: '1em' }}>
                    Popular
                  </span>
                </span>
              ) : null}
            </div>
          </>
        )}

        {paymentType === 'savedCard' && generateSavedCardButton(paymentMethod)}
      </button>
    );
  });
}

const generateSavedCardButton = (paymentMethod) => {
  if (paymentMethod) {
    const { logo, full_name, last_four, expiration_month, expiration_year } =
      paymentMethod;

    return (
      <>
        <div className={styles.firstCol}>
          <img src={logo} alt='Saved card logo' />
        </div>

        <div className={styles.secondCol}>
          <p className={`${styles.description} ${styles.topRow}`}>
            <strong>{full_name}</strong>
          </p>
          <p className={styles.description}>Ending in {last_four}</p>
        </div>

        <div>
          <p className={`${styles.description} ${styles.topRow}`}>
            EXP {expiration_month}/{expiration_year}
          </p>
          <p className={`${styles.description} ${styles.placeHolder}`}>
            PLACEHOLDER
          </p>
        </div>
      </>
    );
  }

  return <></>;
};

const PaymentMethodButtons = (props) => {
  const { selected, clickHandler, buttons } = props;

  const handleClick = (value) => {
    clickHandler(value);
  };

  if (buttons.length < 2) {
    return <></>;
  }

  return (
    <section className={styles.container}>
      {generateButtons(selected, buttons, handleClick)}
    </section>
  );
};

export default PaymentMethodButtons;
